import axios from "axios";
import updateHeaderInterceptor from "./updateHeader";

const httpClient = (token: string) => {
    const client = axios.create({
        baseURL: process.env.REACT_APP_TOPIVO_URL,
    });
    updateHeaderInterceptor(client, token);
    return client
}
export default httpClient;
